import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../shared/shared.module';
import { SelectServiceComponent } from './select-service.component';
import { SelectServiceRoutingModule } from './select-service-routing.module';
import { SelectServiceResolve } from './select-service.resolve';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    SelectServiceRoutingModule,
    MatDialogModule,
    MatCheckboxModule,
  ],
  declarations: [SelectServiceComponent],
  entryComponents: [],
  exports: [SelectServiceComponent],
  providers: [SelectServiceResolve],
})
export class SelectServiceModule {}
